// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * OPC UA StatusCode symbolic name
 * @export
 */
export const UAVariableStatusCode = {
    Good: 'good',
    GoodClamped: 'goodClamped',
    GoodLocalOverride: 'goodLocalOverride',
    Uncertain: 'uncertain',
    UncertainLastUsableValue: 'uncertainLastUsableValue',
    UncertainSubNormal: 'uncertainSubNormal',
    UncertainNoCommunicationLastUsableValue: 'uncertainNoCommunicationLastUsableValue',
    UncertainEngineeringUnitsExceeded: 'uncertainEngineeringUnitsExceeded',
    Bad: 'bad',
    BadUnexpectedError: 'badUnexpectedError',
    BadInternalError: 'badInternalError',
    BadOutOfMemory: 'badOutOfMemory',
    BadCommunicationError: 'badCommunicationError',
    BadEncodingError: 'badEncodingError',
    BadDecodingError: 'badDecodingError',
    BadEncodingLimitsExceeded: 'badEncodingLimitsExceeded',
    BadRequestTooLarge: 'badRequestTooLarge',
    BadResponseTooLarge: 'badResponseTooLarge',
    BadNodeIdInvalid: 'badNodeIdInvalid',
    BadNodeIdUnknown: 'badNodeIdUnknown',
    BadAttributeIdInvalid: 'badAttributeIdInvalid',
    BadNotConnected: 'badNotConnected',
    BadNotReadable: 'badNotReadable',
    BadNotWritable: 'badNotWritable',
    BadOutOfRange: 'badOutOfRange',
    BadIndexRangeInvalid: 'badIndexRangeInvalid',
    BadIndexRangeNoData: 'badIndexRangeNoData',
    BadUserAccessDenied: 'badUserAccessDenied',
    BadNoCommunication: 'badNoCommunication'
} as const;
export type UAVariableStatusCode = typeof UAVariableStatusCode[keyof typeof UAVariableStatusCode];


export function instanceOfUAVariableStatusCode(value: any): boolean {
    for (const key in UAVariableStatusCode) {
        if (Object.prototype.hasOwnProperty.call(UAVariableStatusCode, key)) {
            if (UAVariableStatusCode[key as keyof typeof UAVariableStatusCode] === value) {
                return true;
            }
        }
    }
    return false;
}

export function UAVariableStatusCodeFromJSON(json: any): UAVariableStatusCode {
    return UAVariableStatusCodeFromJSONTyped(json, false);
}

export function UAVariableStatusCodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): UAVariableStatusCode {
    return json as UAVariableStatusCode;
}

export function UAVariableStatusCodeToJSON(value?: UAVariableStatusCode | null): any {
    return value as any;
}

export function UAVariableStatusCodeToJSONTyped(value: any, ignoreDiscriminator: boolean): UAVariableStatusCode {
    return value as UAVariableStatusCode;
}

